
import { useState, useCallback } from 'react';

interface FiltersState {
  nameFilter: string;
  cityFilter: string;
  countryFilter: string;
  sortOption: string;
}

export const useCollectionsFilters = () => {
  const [filters, setFilters] = useState<FiltersState>({
    nameFilter: '',
    cityFilter: '',
    countryFilter: '',
    sortOption: 'recent'
  });

  // Applied filters are what actually get used for filtering
  const [appliedFilters, setAppliedFilters] = useState<FiltersState>({
    nameFilter: '',
    cityFilter: '',
    countryFilter: '',
    sortOption: 'recent'
  });

  const setNameFilter = useCallback((value: string) => {
    setFilters(prev => ({ ...prev, nameFilter: value }));
  }, []);

  const setCityFilter = useCallback((value: string) => {
    setFilters(prev => ({ ...prev, cityFilter: value }));
  }, []);

  const setCountryFilter = useCallback((value: string) => {
    setFilters(prev => ({ ...prev, countryFilter: value }));
  }, []);

  const setSortOption = useCallback((value: string) => {
    setFilters(prev => ({ ...prev, sortOption: value }));
    setAppliedFilters(prev => ({ ...prev, sortOption: value }));
  }, []);

  const handleApplyFilters = useCallback(() => {
    setAppliedFilters({ ...filters });
  }, [filters]);

  const handleClearFilters = useCallback(() => {
    const clearedFilters = {
      nameFilter: '',
      cityFilter: '',
      countryFilter: '',
      sortOption: 'recent'
    };
    setFilters(clearedFilters);
    setAppliedFilters(clearedFilters);
  }, []);

  return {
    filters: appliedFilters,
    rawFilters: filters,
    setNameFilter,
    setCityFilter,
    setCountryFilter,
    setSortOption,
    handleApplyFilters,
    handleClearFilters,
    hasUnappliedChanges: JSON.stringify(filters) !== JSON.stringify(appliedFilters)
  };
};
